import BarChartIcon from '@mui/icons-material/BarChart'
import EventAvailableIcon from '@mui/icons-material/EventAvailable'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ReceiptIcon from '@mui/icons-material/Receipt'
import RouterIcon from '@mui/icons-material/Router'
import SettingsIcon from '@mui/icons-material/Settings'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeSoundAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeSoundAdminCommon'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { CountryEnum } from '@/types/enum/enumUser'
import routeDocumentTemplateRoutes from '@/lib/routes/backoffice/common/routeDocumentTemplateRoutes'

const getBackOfficeSoundAdmin = [
  ...routeBackOfficeSoundAdminCommon,
  {
    route: 'StatProgram',
    text: 'Statistiques programmes',
    icon: BarChartIcon,
    href: '/backoffice/sound/program/stat-program',
    menuHeader: true,
    position: 60,
  },
  {
    // Ex-« Disponibilité emplacements », renommé le 06/10/2026 : créneaux, parc & Ulysse,
    // SIRET et plafond de diffusion, en tuiles.
    route: 'SoundSlotsDashboard',
    text: 'Tableau de bord de pilotage',
    t: 'routes.backoffice.sound.pilotDashboard',
    icon: EventAvailableIcon,
    href: '/backoffice/sound/slots-dashboard',
    menuHeader: true,
    // Premier de « Ma radio », avant « Programme audio » (40) : demande du 06/10/2026.
    position: 30,
  },
  {
    route: 'SoundDeliveryEquipment',
    // Même libellé que l'onglet de Gestion des équipements, qui monte la même liste.
    text: 'Envois et retours',
    icon: LocalShippingIcon,
    href: '/backoffice/sound/delivery-equipment',
    menuHeader: true,
    position: 80,
  },
  {
    route: 'UlysseConnected',
    text: 'Connection Ulysse',
    icon: RouterIcon,
    href: '/backoffice/sound/ulysse-connected',
    menuHeader: true,
    position: 90,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  {
    route: 'SoundMysteryVisit',
    text: 'Visite Mystère',
    icon: VisibilityIcon,
    href: '/backoffice/sound/mystery-visit',
    menuHeader: true,
    position: 100,
    fnDisplay: ({ dataMyProfile }) =>
      dataMyProfile?.countries?.some((country: CountryEnum) =>
        [CountryEnum.FRANCE].includes(country)
      ),
  },
  {
    route: 'EditSoundDeliveryEquipment',
    href: '/backoffice/sound/delivery-equipment/edit/[soundDeliveryEquipmentId]',
    menuHeader: false,
  },
  {
    route: 'AdminSoundGestionFinance',
    text: 'Gestion financière',
    icon: ReceiptIcon,
    href: '/backoffice/sound/finance',
    menuHeader: true,
    position: 50,
  },
  {
    route: 'Settings',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Paramétrage',
    icon: SettingsIcon,
    href: '/backoffice/common/settings',
    menuHeader: true,
    position: 310,
  },
  {
    route: 'AddDocument',
    text: 'Ajouter un document',
    href: '/backoffice/common/document/add-document',
    menuHeader: false,
  },
  {
    route: 'EditDocument',
    text: 'Editer un document',
    href: '/backoffice/common/document/edit-document/[documentId]',
    menuHeader: false,
  },
  {
    route: 'FilterFinance',
    text: 'Export des factures pharmaciens',
    href: '/backoffice/[entity]/finance/export-filter',
  },
  {
    route: 'HistoFinancial',
    text: 'Centre des exports',
    href: '/backoffice/[entity]/finance/export-history',
  },
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeDocumentTemplateRoutes,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDISOUND],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_SOUND_ADMIN],
}))

export default getBackOfficeSoundAdmin
